import React from 'react';
import { Field } from 'redux-form';

import InputInlineEdit from '../../../../common/zolaUI/InputInlineEdit/InputInlineEdit';

const ChecklistTitleForm = ({ ...props }) => (
  <form onSubmit={props.handleSubmit}>
    <Field
      {...props}
      id="task-title"
      placeholder="Add a title..."
      name="title"
      required
      component={InputInlineEdit}
    />
  </form>
);

ChecklistTitleForm.propTypes = {};

ChecklistTitleForm.defaultProps = {};

export default ChecklistTitleForm;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistTask/ChecklistTitleForm/ChecklistTitleForm.jsx